
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-lungs-fill',
      title: 'CPAP Machines',
      description: 'Latest CPAP technology for effective sleep apnea treatment',
      color: 'yellow-500',
      bgColor: 'yellow-50'
    },
    {
      icon: 'ri-heart-pulse-fill',
      title: 'BiPAP Machines',
      description: 'Advanced BiPAP systems for complex respiratory needs',
      color: 'blue-600',
      bgColor: 'blue-50'
    },
    {
      icon: 'ri-shield-check-fill',
      title: 'CPAP Masks',
      description: 'Comfortable, properly fitted masks for optimal therapy',
      color: 'slate-600',
      bgColor: 'slate-50'
    },
    {
      icon: 'ri-tools-fill',
      title: 'CPAP Supplies',
      description: 'Filters, tubing, and replacement parts for your equipment',
      color: 'blue-700',
      bgColor: 'blue-50'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-blue-900 mb-6">
            Our <span className="text-yellow-500">Specialized</span> Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            MediMar Medical Market provides comprehensive home medical equipment solutions 
            specializing in sleep apnea therapy and respiratory care.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className={`bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-t-4 border-${service.color} group`}
            >
              <div className={`w-16 h-16 bg-${service.bgColor} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${service.icon} text-${service.color} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-blue-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-yellow-100 to-blue-100 rounded-2xl p-8 shadow-xl border border-yellow-200">
            <h3 className="text-2xl font-bold text-blue-900 mb-4">
              Need Help Choosing the Right Equipment?
            </h3>
            <p className="text-blue-800 mb-6 text-lg">
              Our experienced team will help you find the perfect CPAP or BiPAP solution for your needs.
            </p>
            <a 
              href="tel:941.286.4000" 
              className="bg-blue-900 hover:bg-blue-800 text-white px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 inline-flex items-center whitespace-nowrap shadow-lg hover:shadow-xl"
            >
              <i className="ri-phone-fill mr-2"></i>
              Call for Consultation
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
